import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { Eyebrow, SectionLead } from './ui/Section';
export function Testimonials() {
  return <section className="border-y border-slate-200 bg-white px-4 py-12 md:py-16" data-id="element-351" data-mp="3fyvxs9ef7bak">
      <div className="mx-auto max-w-3xl" data-id="element-352" data-mp="3b0uebnd319yk">
        <Eyebrow data-id="element-353" data-mp="3azt41l3w4rhw">⭐ Lo que dicen quienes ya construyen</Eyebrow>
        <SectionLead data-id="element-354" data-mp="36zilza2tqamo">
          Sin taller profesional y sin experiencia previa: eligieron un proyecto y lo siguieron paso
          a paso.
        </SectionLead>

        <div className="mt-8 space-y-3" data-id="element-355" data-mp="321za2gtlm9xw">
          {testimonials.map(person => <article key={person.name} className="rounded-2xl border border-slate-200 border-l-4 border-l-sky-600 bg-slate-50 p-5" data-id="element-356" data-mp="2x11tu9s5fpz1">
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-357" data-mp="v8dite99jy8p">
                {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} className="h-4 w-4 fill-yellow-400 text-yellow-400" data-id="element-358" data-mp="q89701javrot" data-mpi={star} />)}
              </div>
              <h3 className="mt-2 text-base font-black leading-snug text-slate-900 md:text-lg" data-id="element-359" data-mp="m5kkcjovulab">
                {person.headline}
              </h3>
              <p className="mt-1.5 text-sm font-medium leading-relaxed text-slate-600 md:text-base" data-id="element-360" data-mp="79lezgt5qz8v">
                {person.text}
              </p>
              <p className="mt-3 flex flex-wrap items-center gap-x-2 text-sm" data-id="element-361" data-mp="zvwe0n148s3k">
                <span className="flex items-center gap-1 font-black text-slate-900" data-id="element-362" data-mp="14vj3buu7xysq">
                  {person.name}
                  <BadgeCheckIcon className="h-4 w-4 text-sky-600" aria-label="Compra verificada" data-id="element-363" data-mp="q7650r7ns3v2" />
                </span>
                <span className="font-semibold text-slate-500" data-id="element-364" data-mp="v4o4lqzsd6qe">
                  {person.age} años · {person.city}
                </span>
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}